import React from 'react';
import PropTypes from 'prop-types';
import './PaymentType.css';

function PaymentType({
  type, contribution, margin,
}) {
  return (
    <td style={{ margin: `${margin}px 0` }} className="d-block text-center">
      <div id="payment-type" className="bg-blue d-flex flex-column justify-content-between">
        <div className="d-flex justify-content-between align-items-center">
          <div className="top-left" />
          <div className="top-right" />
        </div>
        <p className="text-center text-uppercase">{type}</p>
        <div className="d-flex justify-content-between align-items-center">
          <div className="bottom-left" />
          <div className="bottom-right" />
        </div>
      </div>
      <p className="text-uppercase my-0"><strong>{contribution}</strong></p>
    </td>
  );
}

PaymentType.propTypes = {
  type: PropTypes.string.isRequired,
  contribution: PropTypes.string.isRequired,
  margin: PropTypes.string.isRequired,
};

export default PaymentType;
